import { useLayoutContext } from '../../context/layoutContext'
import {
  isSimpleTemplateField,
  type TemplateField,
} from '../../types/templateModel'
import { TemplateFieldType } from '../templateFieldType/TemplateFieldType'
import { CompositeFieldTypeValidationsCell } from './CompositeFieldTypeValidationsCell'
import { SimpleFieldTypeFramesCell } from './SimpleFieldTypeFramesCell'
import { TemplateFieldNameCell } from './TemplateFieldNameCell'
import { TemplateFieldRequiredCell } from './TemplateFieldRequiredCell'
import { TemplateFieldValue } from './TemplateFieldValue'

type Props = {
  field: TemplateField
  column: number
  isHeaderRow: boolean
}

export const TemplateFieldCell = ({ field, column, isHeaderRow }: Props) => {
  const {
    preferences: {
      templates: { isShowingSimplifiedView },
    },
  } = useLayoutContext()

  switch (column) {
    case 0:
      return <TemplateFieldNameCell isHeaderRow={isHeaderRow} field={field} />
    case 1:
      return isShowingSimplifiedView ? (
        <TemplateFieldValue field={field} />
      ) : (
        <TemplateFieldType field={field} />
      )
    case 2:
      return <TemplateFieldRequiredCell field={field} />
    case 3:
      return <TemplateFieldValue field={field} />
    case 4:
      return isSimpleTemplateField(field) ? (
        <SimpleFieldTypeFramesCell field={field} />
      ) : (
        <CompositeFieldTypeValidationsCell field={field} />
      )
    default:
      throw new Error(`Nonexistent column ${column}`)
  }
}
